import { getDomainUrl } from 'core/utils';

export const projectListPath = () => '/project/list';
export const projectDetailsPath = (id: number | string = ':id') => `/project/${id}`;

export const oldProjectListPath = () => `${getDomainUrl()}/project/list`;

export const oldProjectJobListPath = (projectId: number | string = ':projectId') =>
  `${getDomainUrl()}/bom/list?project=${projectId}`;
